var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"totalRows":_vm.totalRecord,"headers":_vm.headers,"fields":_vm.fields,"items":_vm.notifications,"addAction":'new-notification',"title":"Notifications"}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6edb50","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/notifications/NotificationHistory.vue
// module id = FAVG
// module chunks = 0 1